import { render, staticRenderFns } from "./popupPg.vue?vue&type=template&id=4f6ebe75&scoped=true"
import script from "./popupPg.vue?vue&type=script&lang=js"
export * from "./popupPg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ebe75",
  null
  
)

export default component.exports